import { KYMW00Model } from '../kymw00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from '../pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページロック情報を取得する
 *
 * @export API通信成功時の処理
 * @class PageLockService
 * @extends {PlessResponder}
 */
@Injectable()
export class PageLockService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: KYMW00Model = null;
  private vo: any = null;
  private successFunction: Function = null;
  private lockType: string = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof PageLockService
   */
  private getBodyRegist(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        PageId: this.vo.pageId,
        FormId: this.vo.formId,
        UserId: this.vo.userId,
        CheckOnly: this.vo.checkOnly
      }
    });
  }

  /**
 * bodyにセットする値を返す
 *
 * @private
 * @returns {PlessRequest} リクエストJSON
 * @memberof PageLockService
 */
  private getBodyRelease(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        PageId: this.vo.pageId,
        FormId: this.vo.formId,
        UserId: this.vo.userId ? this.vo.userId.trim() : this.vo.userId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW00Model} model モデルクラス
   * @param {*} vo パラメータ
   * @param {Function} successFunction 成功時後続処理
   * @memberof PageLockService
   */
  execute(model: KYMW00Model, vo: any, type: string) {
    this.model = model;
    this.vo = vo;
    if (type === model.EVENT_LOCK_PAGE_REGIST) {
      this.lockType = 'REGIST';
      this.send('KYMW02registPageLock', this.getBodyRegist());
    } else if (type === model.EVENT_LOCK_PAGE_RELEASE) {
      this.lockType = 'RELEASE';
      this.send('KYMW02releasePageLock', this.getBodyRelease());
    } else {
      this.lockType = 'CHECK';
      this.send('KYMW02registPageLock', this.getBodyRegist());
    }
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof PageLockService
   */
  success(_: any) {
    if (this.lockType === 'REGIST') {
      // ロック登録に成功した場合
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, false);
      } else if (this.lockType === 'RELEASE') {
      // ロック解除に成功した場合
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, false);
    }

    if (this.vo.viewControl === true) {
      this.vo.viewHelper.setScreenMode(this.model.kymw1001Model.setScreenModeOnNowFunc(this.model.kymw1001Model.topFuncID));
    }

    if (this.vo.successFunc != null) {
      this.vo.successFunc(this.vo.successParam);
    }
  }

  /**
   * API通信失敗時処理
   *
   * @param {*} result
   * @memberof PageLockService
   */
  lockErrorHandler(result: any): void {
    if (this.lockType === 'REGIST') {
      // ロック登録に失敗した場合
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, true);
      if (this.vo.viewControl === true) {
        this.vo.viewHelper.setScreenMode('true');
      }
      if (this.vo.faultFunc != null) {
        this.vo.faultFunc(this.vo.faultParam , result);
      }
    } else if (this.lockType === 'RELEASE') {
      // ロック解除に失敗した場合
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, false);
    }

    if (this.lockType !== 'REGIST') {
       if (this.vo.faultFunc != null) {
          this.vo.faultFunc(this.vo.faultParam);
        }
    }
  }

}
